.form {
	@apply yst-space-y-6;
}

.button {
	@apply yst-w-full;
}

.newsletterConsent {
	@apply yst-flex yst-items-start yst-gap-2;
}

.rememberForgot {
	@apply yst-flex yst-flex-col sm:yst-flex-row yst-justify-between yst-items-start sm:yst-items-center yst-gap-4;
}

.passkeyButton {
	@apply yst-w-full yst-inline-flex yst-items-center yst-justify-center yst-gap-2;
}

.passkeyIcon {
	@apply yst-w-5 yst-h-5;
}

.passkeyDivider {
	@apply yst-flex yst-items-center yst-gap-4;
}

.dividerLine {
	@apply yst-flex-1 yst-border-slate-300;
}

.dividerText {
	@apply yst-text-sm yst-text-slate-500;
}
